module.exports = __webpack_public_path__ + "img/118.6536823f.jpg";